import React from "react";

const Error = () => {
  return (
    <div className="error-container">
      <div className="error-wrap">
        <h1>Please Allow permission for camera to play Rock-Paper-Scissor !</h1>
        <button
          className="next-button"
          onClick={() => {
            window.open(window.location.origin);
          }}
        >
          Home
        </button>
      </div>
    </div>
  );
};

export default Error;
